/**
 * Combine multiple arrays in new sets by taking elements from each one and preserve the order.
 * eg. cartesianProduct(['a', 'b'], [1, 2]) = [['a', 1], ['a', 2], ['b', 1], ['b', 2]]
 */
export const cartesianProduct = <T extends unknown[]>(...arrays: unknown[][]): T[] =>
  arrays.reduce((a, b) => a.flatMap((d) => b.map((e) => [d, e].flat()))) as T[];
